module.exports = __webpack_public_path__ + "b7623cd5ff027186dea74b55ff69c979.png";